import axios from 'axios';
import * as Sentry from '@sentry/react';
import { contactUrl } from './config';
import { event, logAmpEvent } from './Amplitude';

export function SubmitContactUs(data) {
  // replace ios apostrophe
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value && typeof value === 'string') {
      data[key] = value.replace(/[‘’]/g, "'");
    }
  });

  return new Promise((resolve, reject) => {
    axios
      .post(contactUrl(), JSON.stringify(data), { headers: { 'x-api-key': process.env.REACT_APP_LAMBDA_X_API_KEY } })
      .then((result) => {
        if (result.status === 200) {
          logAmpEvent(event.USER_CONTACT_US_SUBMIT_SUCCESS, { Brand: data.BrandID });
          resolve(200);
        } else {
          logAmpEvent(event.USER_CONTACT_US_SERVER_ERROR, {
            Brand: data.BrandID,
            Reason: result.data,
          });
          reject(result.data);
        }
      })
      .catch((err) => {
        logAmpEvent(event.USER_CONTACT_US_SERVER_ERROR, {
          Brand: data.BrandID,
          Reason: err.message,
        });
        Sentry.captureEvent(err);
        reject(err);
      });
  });
}

export function ShowContactError(id) {
  const errorElement = document.getElementById(id);
  const fieldset = errorElement.closest('fieldset');
  if (!fieldset) {
    errorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }
  const legend = fieldset.querySelector('legend');
  if (legend) {
    legend.scrollIntoView({ behavior: 'smooth', block: 'start' });
    legend.focus?.({ preventScroll: true });
  } else {
    fieldset.scrollIntoView({ behavior: 'smooth', block: 'start' });
    fieldset.focus?.({ preventScroll: true });
  }
}

export function hideContactError(id) {
  try {
    const errorMsg = document.getElementById(id);
    errorMsg.style.display = 'None';
    errorMsg.removeAttribute('role');
  } catch (e) {
    return undefined;
  }
  return undefined;
}

export function logErrorToAmp(errorList) {
  if ((typeof errorList) === 'object') {
    errorList.forEach((err) => {
      logAmpEvent(event.USER_ERROR_CONTACT, { 'Error Type': err });
    });
  } else {
    logAmpEvent(event.USER_ERROR_CONTACT, { 'Error Type': errorList });
  }
}
